function empty() {
  return [];
}

export default function(selector) {
  return selector == null ? empty : function() {
    return this.querySelectorAll(selector);
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/selectorAll.js
// module id = 644
// module chunks = 0